export const ROUTE_CONSTANT = {
  THEME_HISTORY: "/theme-history",
  THEME_DISCOVER: "/theme-discover",
  WHATSAPP_MARKETING_WEBVIEW: "/webview/whatsapp-business-marketing",
  BUSINESS_CARDS_ROUTE: "business-cards",
  QR_ROUTE: "qr",
};

export const HELP_SECTION_URL = "https://digitalshowroom.in/help-section/";